import * as React from "react";
function PlagiarismIcon({ title, titleId, className, ...props }, svgRef) {
	return (
		<svg
			ref={svgRef}
			className={className}
			id="performance-icon"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="transparent"
			stroke="currentColor"
			aria-hidden="true"
			aria-labelledby={titleId}>
			{title && <title id={titleId}>{title}</title>}
			<path d="M 21 6 A 7 7 0 1 0 21, 14" strokeWidth="2.5" />
			<path d="M 3 21	L 10.5 14" strokeWidth="2.5" />
		</svg>
	);
}
const ForwardRef = React.forwardRef(PlagiarismIcon);
export default ForwardRef;
